module.exports = __webpack_public_path__ + "media/content-creator/pets-3-0c06b4f0.png";